<template>
  <main>
    <div class="row border p-3 rounded-3 mx-1 mb-3">
      <div class="col-12 d-flex">
        <label class="me-2">Date of Notice: </label> <span> {{ state.DateOfNotice }}</span>
      </div>
      <div class="col-6 mt-2 d-flex" v-if="!hideChildName">
        <label class="me-2">Name of Child: </label> <span> {{ state.Full_Name }}</span>
      </div>
      <div class="mt-2" :class="hideChildName ? 'col-12 row' : 'col-6'">
        <div class="d-flex" :class="hideChildName && 'col-6'">
          <label class="me-2">Child Year/Grade Level: </label> <span> {{ state.CRS_Level }}</span>
        </div>
        <div class="d-flex" :class="hideChildName && 'col-6'">
          <label class="me-2">Class: </label> <span> {{ state.CLS_ClassName }}</span>
        </div>
      </div>
      <div class="col-12 d-flex mt-2">
        <div class="me-2" style="min-width: 180px">
          <label class="me-2">* Student Name:</label>
        </div>
        <input class="form-control" type="text" v-model="state.StudentName" :disabled="readonly" />
      </div>
      <div class="col-12 d-flex mt-2">
        <div class="me-2" style="min-width: 180px"><label class="me-2">* Student Pass Holder:</label> <span>(Select where applicable) </span></div>
        <select class="form-control" :value="selected" @change="changeStudPassHolder($event)" :disabled="readonly">
          <option value="Yes">Yes</option>
          <option value="No">No</option>
        </select>
      </div>
      <div class="col-12 mt-3 border-top pt-3" v-if="isInternationalSchool">
        <ol>
          <li>I wish to inform the School of my intention to withdraw my child from the above-mentioned class.</li>

          <li>I understand that any amount of fees to be refunded will be subjected to the relevant Student Contract’s Terms & Conditions.</li>
          <li>
            I understand that once my child has formally withdrawn from the School, re-registration at EtonHouse schools will not be permitted unless approved
            by the Board of Management.
          </li>
        </ol>
      </div>
      <div class="col-12 mt-3 border-top pt-3" v-else>
        <ol>
          <li>I wish to inform the School of my intention to withdraw my child from the above-mentioned class.</li>

          <li>
            I understand that a notice period of minimum 8 fee-paying term-weeks, prior to the withdrawal date, should be given in order to receive a full
            refund of the deposit.
          </li>

          <li>
            I understand that once my child has formally withdrawn from the School, re-registration at EtonHouse schools will not be permitted unless approved
            by the Board of Management.
          </li>
        </ol>
      </div>
    </div>
  </main>
</template>

<script>
import ApfBasicInput from '../component/WdfBasicInput.vue'
import { getValidationMessageFromKey } from '../component/data'

export default {
  components: { ApfBasicInput },
  props: ['readonly', 'state', 'isInternationalSchool', 'hideChildName'],
  data() {
    return {
      selected: '',
      StudentName: '',
    }
  },
  mounted() {
    this.selected = this.state?.StudentPass
    this.StudentName = this.state?.StudentName
  },
  watch: {
    state: function (val) {
      this.selected = val.StudentPass
      this.StudentName = val?.StudentName
    },
    StudentName(val) {
      this.$emit('StudentName', val)
    },
  },
  methods: {
    getValidationMessageFromKey,
    async changeStudPassHolder(event) {
      this.selected = event.target.value
      this.$emit('change', this.selected)
    },
  },
}
</script>
